import { render } from "./regionView.vue?vue&type=template&id=06c17a29&scoped=true"
import script from "./regionView.vue?vue&type=script&lang=js"
export * from "./regionView.vue?vue&type=script&lang=js"

import "./regionView.vue?vue&type=style&index=0&id=06c17a29&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c17a29"]])

export default __exports__